import { render, staticRenderFns } from "./erweima.vue?vue&type=template&id=18b2c7b8&scoped=true"
import script from "./erweima.vue?vue&type=script&lang=js"
export * from "./erweima.vue?vue&type=script&lang=js"
import style0 from "./erweima.vue?vue&type=style&index=0&id=18b2c7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b2c7b8",
  null
  
)

export default component.exports